import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.svg';
import { useLocation } from 'react-router-dom';

const styles = {
  page: {
    minHeight: '100vh', backgroundColor: '#f0f4f8',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Segoe UI', sans-serif",
  },
  card: {
    backgroundColor: '#fff', borderRadius: '12px', padding: '48px 40px',
    width: '100%', maxWidth: '420px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)', textAlign: 'center',
  },
  icon: { fontSize: '48px', marginBottom: '16px' },
  title: { fontSize: '22px', fontWeight: '700', color: '#111827', marginBottom: '12px' },
  desc: { fontSize: '15px', color: '#4b5563', lineHeight: '1.7', marginBottom: '32px' },
  btn: {
    display: 'inline-block', backgroundColor: '#0052CC', color: '#fff',
    border: 'none', borderRadius: '8px', padding: '12px 32px',
    fontSize: '15px', fontWeight: '600', cursor: 'pointer',
  },
};

export default function VerifyEmail() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <img src={logo} alt="V2VLab" style={{ height: '36px', marginBottom: '24px', cursor: 'pointer' }} onClick={() => navigate('/')} />
        <div style={styles.icon}>📧</div>
        <div style={styles.title}>Check your email</div>
        <div style={styles.desc}>
          We sent a verification link to {email ? <strong>{email}</strong> : 'your email address'}. Click the link to verify your account before signing in.
        </div>
        <button style={styles.btn} onClick={() => navigate('/login')}>
          Go to Sign In
        </button>
      </div>
    </div>
  );
}
